




// @ is an alias to /src
import Vue from 'vue'

export default Vue.extend({
  name: 'About',
  props: ['about'],
});
